import { SetState } from 'zustand';
import { CorporateContentQueryDetailsFragment } from 'generated/graphql';
import { UpdateCorporateContentQueryState } from 'stores/interfaces/UpdateQueryState';

export const createUpdateCorporateContentQuerySlice = (
  set: SetState<UpdateCorporateContentQueryState>
) => ({
  setInitialStateWithProps: (queryDetails: CorporateContentQueryDetailsFragment) =>
    set({
      xtmProjectName: queryDetails.xtmProjectNameCC || undefined,
      fileName: queryDetails.fileName
    })
});
